import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function Seo({ title, description, image = "/images/hero.jpeg", type = "website", jsonLd, noindex = false }) {
  const { lang } = useApp();
  const { pathname } = useLocation();
  const brand = lang === "ar" ? "واحة التمور" : "Dates Oasis";
  const fullTitle = pathname === "/" ? `واحة التمور — ${title}` : `${title} | ${brand}`;
  const canonical = `${BASE}${pathname}`;
  const img = image.startsWith("http") ? image : `${BASE}${image}`;
  const ld = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <html lang={lang} dir={lang === "ar" ? "rtl" : "ltr"} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex" />}
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="ar" href={canonical} />
      <link rel="alternate" hrefLang="en" href={`${canonical}?lang=en`} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={lang === "ar" ? "ar_SA" : "en_US"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {ld.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}
